import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { get } from '../../../../lib/api';
import { useNotification } from '../../../../shared/Notification/useNotification';
import { uploadFile } from '../../../../shared/AwsS3/ReactS3Client';
import { useGetAwsData } from '../../../../shared/TileForm/hooks/useGetAwsData';

export const useUserUploadForm = ({ campaingId, closeModal, isSegment }) => {
  const [file, setFile] = useState({});
  const { showSuccess, showError } = useNotification();
  const { t } = useTranslation('campaigns');
  const awsData = useGetAwsData({ origin: 'users' });

  const handleFileInput = e => {
    e.preventDefault();
    setFile(e.currentTarget.files[0]);
  };

  const submitUpload = async e => {
    e.preventDefault();
    const fileName = file.name;
    const key = `${awsData.key}/${fileName}`;

    try {
      await uploadFile({
        ...awsData,
        key,
        file,
        fileName,
      });

      await get('/api/client_admin/campaigns/bulk_uploads', {
        campaign_id: campaingId,
        bucket: awsData.bucket,
        key,
        is_segment: isSegment,
      });

      showSuccess({
        content: t('upload.uploadSuccess.body'),
        title: t('upload.uploadSuccess.title'),
      });
    } catch {
      showError({
        content: t('upload.uploadError.body'),
      });
    } finally {
      closeModal();
    }
  };

  return { handleFileInput, submitUpload, file };
};

export const useGetTotalUsers = () => {
  const { data = { totalUsers: 0 } } = useQuery(
    ['getTotalUsers'],
    () => get('/api/client_admin/users/total_users'),
    { staleTime: Infinity },
  );

  return { data };
};
